<template>
  <div class="yxtbiz-teacher-edit-audit">
    <div
      v-loading="loading"
      class="standard-size-16 color-gray-10"
    >
      <template v-if="baseInfo.templateList && baseInfo.templateList.length">
        <div
          v-for="item in baseInfo.templateList"
          :key="item.fieldCode"
          class="mb35 font-bolder"
        >
          {{ item.fieldName }}
          <yxtf-row
            type="flex"
            class="mv24 font-normal font-size-14"
          >
            <yxtf-col
              :span="24"
              class="mh2 felx-center"
            >
              <div
                v-if="item.customerType === CUSTOM_TYPES.IMAGE"
                class="mt8"
              >
                <yxt-image
                  v-if="item.content"
                  class="width120 height120 b-radius4"
                  :src="item.content"
                  :preview-src-list="[item.content]"
                />
                <div v-else class="color-gray-7">--</div>
              </div>
              <yxtf-tooltip
                v-else
                :open-filter="true"
                placement="top"
              >
                <div slot="content">
                  <span> {{ item.content || '--' }}</span>
                </div>
                <div class="color-gray-7">
                  {{ item.content || '--' }}
                </div>
              </yxtf-tooltip>
            </yxtf-col>
          </yxtf-row>
        </div>
      </template>
      <div v-else class="color-gray-7">{{ $t('pc_biz_tip_teacher_field_deleted').d('本次修改的讲师字段已被删除')}}</div>
    </div>
  </div>
</template>

<script>
import { getDraftDetail } from './service';
import { CUSTOM_TYPES } from './const';
export default {
  name: 'YxtbizTeacherEditAudit',
  name_zh: '讲师信息修改审核',
  eventList: [
  ],
  props: {
    // 审核ID 5caf68a9-3aa3-4434-bf14-6c2f6b00dff6
    formId: {
      type: String,
      default: '',
      desc: '审核 formId',
      setter: 'StringSetter'
    }
  },
  data() {
    return {
      CUSTOM_TYPES,
      loading: false,
      baseInfo: {} // 审核信息
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      if (!this.formId) return false;
      this.loading = true;
      getDraftDetail(this.formId)
        .then(res => {
          this.baseInfo = {
            templateList: res.templateList.map(item => {
              switch (item.customerType) {
                case CUSTOM_TYPES.TIME_RANGE:
                  item.content = item.content.replace('|', ' ~ ');
                  break;
                case CUSTOM_TYPES.SELECT:
                  const option = item.customerItemList.find(option => option.id === item.content);
                  item.content = option ? option.itemContent : '';
                  break;
              }
              return item;
            })
          };
        }).catch(e => {
        }).finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
